import { render, staticRenderFns } from "./Diagnosticos.vue?vue&type=template&id=bf254840&scoped=true&"
import script from "./Diagnosticos.vue?vue&type=script&lang=js&"
export * from "./Diagnosticos.vue?vue&type=script&lang=js&"
import style0 from "./Diagnosticos.vue?vue&type=style&index=0&id=bf254840&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf254840",
  null
  
)

export default component.exports